export default {
    namespaced: true,
    state: {
        key: Math.random(),
        effects: {}
    },
    getters: {

    },
    mutations: {
        ChangeStatus(state, { apikey, status }) {
            // console.log(apikey, status, "loading commit")
            const { effects } = state
            effects[apikey] = status
            state.effects = effects
            state.key = Math.random()
        },
    },
    actions: {

    }
}